import { render, staticRenderFns } from "./SelectClassificacao.vue?vue&type=template&id=7f986479"
import script from "./SelectClassificacao.vue?vue&type=script&lang=js"
export * from "./SelectClassificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports